export class Events {
    private static prefix = 'events';

    private static Generate(name: string): string {
        name = name
            .toLocaleLowerCase()
            .replace(new RegExp('-', 'g'), '_');
        return `${Events.prefix}.${name}`;
    }
}

export class Constants {

}

export const MeasurementCategories = {

    Symptoms: 'symptoms',
    BloodPressure: 'blood-pressure',
    ObjectivePsychic: 'objective-psychic',
    Medicine: 'medicine',
    Anamnesis: 'anamnesis',

};

export const MeasurementIdentifiers = {

    // Symptoms
    WeightLoss: 'weight-loss',
    Fever: 'fever',
    Tiredness: 'tiredness',
    SleepDisturbances: 'sleep-disturbances',
    Headache: 'headache',
    Migraine: 'migraine',
    VisionDisorders: 'vision-disorders',
    Dizziness: 'dizziness',
    SensoryDisturbances: 'sensory-disturbances',
    Breathlessness: 'breathlessness',
    HeartPalpitations: 'heart-palpitations',
    ChestPain: 'chest-pain',
    LowerLegSwelling: 'lower-leg-swelling',
    Cough: 'cough',
    MucusFormation: 'mucus-formation',
    AbdominalPains: 'abdominal-pains',
    Nausea: 'nausea',
    AcidReflux: 'acid-reflux',
    Heartburn: 'heartburn',
    Vomiting: 'vomiting',
    WeightGain: 'weight-gain',
    HardStools: 'hard-stools',
    UrinationProblems: 'urination-problems',
    MenstrualProblems: 'menstrual-problems',
    Menopause: 'menopause',
    ArmsLegsSkinJoints_Pain: 'arms-legs-skin-joints_-pain',
    ArmsLegsSkinJoints_Tingling: 'arms-legs-skin-joints_-tingling',
    ArmsLegsSkinJoints_Sting: 'arms-legs-skin-joints_-sting',
    ArmsLegsSkinJoints_Rash: 'arms-legs-skin-joints_-rash',
    ArmsLegsSkinJoints_Swelling: 'arms-legs-skin-joints_-swelling',
    ArmsLegsSkinJoints_ReducedMobility: 'arms-legs-skin-joints_-reduced-mobility',

    // Objective psychic
    Anxiety: 'anxiety',
    Depression: 'depression',
    Stress: 'stress',
    SuicidalThoughts: 'suicidal-thoughts',

    // Anamnesis
    Alcohol: 'alcohol',
    Tobacco: 'tobacco',
    Drugs: 'drugs',
    DispositionsForCommonDiseases: 'dispositions-for-common-diseases',
    DispositionsForMentalDiseases: 'dispositions-for-mental-diseases',
    PreviousIllnessesAndTreatments: 'previous-illnesses-and-treatments',
};
